
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const vne: IProductData = {
  id: "hazelriggindustries-vne",
  name: "Hazelrigg Industries VNE",
  description: "Single Channel Vacuum Tube Compressor",
  specialOrder: true,
  images: ["/img/hazelriggindustries_vne_front.png", "/img/hazelriggindustries_vne_back.png"],
  details: [{
    label: "Description",
    markdown: `
Ideal for tracking and mixing, the Hazelrigg Industries VNE features an all Class-A vacuum tube audio path, like all D.W.  
Fearn and Hazelrigg Industries products.  
As originally introduced in the D.W.Fearn VT-7 Stereo Tube Compression Amplifier, the gain reduction circuit utilizes readily available tubes to deliver classic tube compressor performance, while employing an innovative Pulse Width Modulation control circuit to drive the compression.  

The combination of this precision PWM control methodology and D.W.  
Fearn’s high fidelity compression amplifier design result in an audio tool that delivers comprehensive dynamics control, without imparting unwanted tonal artifacts on the source material.  

In use, the VNE can be applied as subtly or aggressively as desired while retaining a beautifully transparent sonic signature.  
As with all D.W.Fearn and Hazelrigg Industries offerings, each component has been hand selected for superior audio performance and rock-solid reliability and – most importantly - critical decisions in the development process were made during rigorous listening tests to ensure that the resulting device delivers superlative audio performance on any source, and on any session.

In addition, the front panel of the VNE has been designed for fast, easy and intuitive operation and includes controls for Threshold, Attack, Release and Gain as well as a three-way rotary switch allowing the user to bypass compression or to insert a High-Pass Filter (HPF) in the side-chain to reduce the gain-reduction sensitivity to low frequencies.  
This is a gentle roll-off, nominally at 100Hz, to avoid heavy low-frequency transients from overly modulating the audio level.  
`
  }, {
    label: "Specification",
    markdown: `
- Transformer Coupled Input and Output
- THD: less than 0.07%
- Pulse Width Modulation Compression as employed in the D.W. Fearn VT-7
- Frequency Response: 20Hz – 20kHz +/- 0.5dB
- -3dB at 5Hz and 65kHz
- All-Tube Signal Path
- Front Panel Output Level Indicator
- THD: less than 0.07%
- Signal to Noise Radio: better than 80dB
- Rear Panel Balanced Line Input (XLR)
- Rear Panel Balanced Line Output (XLR)
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/vne-compressor" target="_blank">https://www.hazelriggindustries.com/vne-compressor</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/3QEbrOD0Kp0?si=wjwVazodijancFcz"],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.RACK, HASHTAGS.ONE_U, HASHTAGS.COMPRESSOR],
    manufacturer: BRAND.HAZELRIGG,
  }
}